import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import type { accountsTypes } from 'app-components/flux/accounts';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

import { type onboardA2ADialogIndex } from './onboardA2ADialogIndexEnums';
import { type TransferDialogIndex } from './transferDialogIndexEnums';

// # -  AccountTransfersDialog
// # - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
export const DIALOG_TYPE_ACCOUNTS_TRANSFERS = 'DIALOG_TYPE_ACCOUNTS_TRANSFERS';

export type TransferOptions = {
  fromAccount?: accountsTypes.Account;
  toAccount?: accountsTypes.Account;
  transferAmount?: number;
};

export type AccountTransfersDialogProps = {
  onClose?: (isError?: boolean) => void;
  dialogId?: string; // set automatically for uncontrolled dialog
  onCreation?: () => void;
  startingIndex?: TransferDialogIndex; // string Enum
  transferOptions?: TransferOptions;
  disableBack?: boolean;
  initiator: string; // for mixpanel events
};

export const showInitiateTransferDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props: AccountTransfersDialogProps) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE_ACCOUNTS_TRANSFERS,
      allowNesting: true,
      props: ImmutableMap(props),
    }),
);

export type AccountLockoutDialogProps = {
  onClose?: () => void;
  errorCode?: string;
  dialogId?: string; // set automatically for uncontrolled dialog
  fundingAccountId?: string;
};

export const DIALOG_TYPE_FUNDING_ACCOUNT_LOCKOUT = 'DIALOG_TYPE_FUNDING_ACCOUNT_LOCKOUT';

export const showAccountLockoutDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props: AccountLockoutDialogProps) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE_FUNDING_ACCOUNT_LOCKOUT,
      allowNesting: true,
      props: ImmutableMap(props),
    }),
);

// # -  MicrodepositConfirmationDialog
// # - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
export const DIALOG_TYPE_MICRODEPOSIT_CONFIRMATION_FOR_TRANSFERS =
  'DIALOG_TYPE_MICRODEPOSIT_CONFIRMATION_FOR_TRANSFERS';

export type MicrodepositConfirmationDialogProps = {
  onClose?: () => void;
  dialogId?: string; // set automatically for uncontrolled dialog
  fundingAccountId?: string;
  hideAccountPicker?: boolean;
  initiator: string;
};

export const showMicrodespositDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props: MicrodepositConfirmationDialogProps) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE_MICRODEPOSIT_CONFIRMATION_FOR_TRANSFERS,
      allowNesting: true,
      props: ImmutableMap(props),
    }),
);

// # -  OnboardAcconutsForTransfers
// # - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
export const DIALOG_TYPE_ONBOARD_ACCOUNTS_FOR_TRANSFERS = 'DIALOG_TYPE_ONBOARD_ACCOUNTS_FOR_TRANSFERS';

export type OnboardAccountsForTransfersDialogProps = {
  onClose?: () => void;
  dialogId?: string; // set automatically for uncontrolled dialog
  startTabIndex?: onboardA2ADialogIndex;
  initialInstitutionId?: string;
  initialAccountId?: string;
  initiator?: string;
  overrideOpening?: boolean;
};

export const showOnboardAccountsDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props: OnboardAccountsForTransfersDialogProps) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE_ONBOARD_ACCOUNTS_FOR_TRANSFERS,
      allowNesting: true,
      props: ImmutableMap(props),
    }),
);

// # -  TransferActivityDetails
// # - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
export const DIALOG_TYPE_TRANSFER_ACTIVITY_DETAILS = 'DIALOG_TYPE_TRANSFER_ACTIVITY_DETAILS';

export type TransferActivityDetailsProps = {
  // converted from propTypes package so maybe be incorrect
  onClose?: () => void;
  dialogId?: string; // set automatically for uncontrolled dialog
  transfer: any;
  sendingInstitutionName: string;
  sendingAccountName: string;
  receivingInstitutionName: string;
  receivingAccountName: string;
  sendingAccountNumber: string;
  receivingAccountNumber: string;
  handleCancel: () => void;
  cancelState: string;
};

export const showTransferActivityDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props: TransferActivityDetailsProps) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE_TRANSFER_ACTIVITY_DETAILS,
      allowNesting: true,
      props: ImmutableMap(props),
    }),
);
